<script setup>
import { onMounted, ref } from 'vue';
import { useCountriesStore } from '@/stores/countries';
const countriesStore = useCountriesStore();

let countryId = ref(1);

onMounted(async () => {
    await countriesStore.fetchCities(countryId.value);
});

const handleCountryChange = async (e) => {
    countryId.value = parseInt(e.target.value, 10);
    await countriesStore.fetchCities(countryId.value);
};
</script>
<template>
    <div class="relative bg-black">
            <div class="grid sm:grid-cols-2 bg-black">
                <div class="min-h-full sm:min-h-full order-2 sm:order-1 bg-black text-white py-10 px-5 sm:px-2">
                    <div class="flex flex-col justify-between items-center  ">
                        <div class="flex justify-center"><img src="@/assets/images/columbia-light.svg" alt="" srcset=""
                                class="logo"></div>
                        <div class=" max-w-xl">
                            <!-- <h3 class="uppercase text-center font-bold text-3xl sm:text-4xl">ENCUÉNTRANOS EN GUATEMALA</h3> -->
                            <div class="flex justify-center mt-4 sm:mt-0">
                                <select @change="handleCountryChange">
                                    <option value="" disabled selected>Selecciona el país</option>
                                    <option value="1">Guatemala</option>
                                    <option value="5">Costa Rica</option>
                                    <option value="6">Panamá</option>
                                </select>
                            </div>


                            <p class="py-4 text-xl leading-5 text-center " v-if="countryId === 1">

                                Encuentra nuestras tiendas en <strong>Guatemala</strong> y adquiere el mejor equipamiento y
                                vestimenta para tus actividades al aire libre.</p>
                            <p class="py-4 text-xl leading-5 text-center " v-if="countryId === 5">

                                Encuentra nuestras tiendas en <strong>Costa Rica</strong>  y adquiere el mejor equipamiento y
                                vestimenta para tus actividades al aire libre.</p>
                            <p class="py-4 text-xl leading-5 text-center" v-if="countryId === 6">
                                Encuentra nuestras tiendas en <strong>Panamá</strong>  y adquiere el mejor equipamiento y vestimenta para tus actividades al aire libre. <span class="hidden">Obtén *20% de descuento en toda la tienda. *No aplica promoción, sobre promoción.</span></p>

                            <div class="mt-6 grid grid-cols-2 lg:grid-cols-3 gap-5">
                                <div class="" v-for="(item, index) in countriesStore.cities.data" :key="index">
                                    <p class="text-xl 2xl:text-2xl font-bold text-center leading-5">{{ item.name }}</p>
                                    <p class="text-sm 2xl:text-lg text-center mt-1">{{ item.address }}</p>
                                </div>
                                
                            </div>
                        </div>
                        <div class="w-full flex items-center justify-center px-5 xl:px-20  ">
                        </div>
                    </div>
                </div>
                <div class="bg-section order-1 sm:order-2 py-5 lg:min-h-screen ">
                    <div class="flex justify-end sm:justify-start px-10 sm:px-20 items-end h-full">
              
                    </div>
                </div>

            </div>
    </div>
</template>
<style scoped>
.logo {
    width: 100%;
    max-width: 250px ;
    margin-bottom: 20px;
    height: auto;
}

select {
    background-color: white;
    color: black;
    padding: 5px 10px;
    border: none;
    border-radius: 5px;

}

.bg-section {
    background-image: url('@/assets/img/footer.jpg');
    background-size: cover ;
    background-position: center;
    
    background-repeat: no-repeat;
    height: 100%;
}



@media screen and (max-width: 767px) {
    .bg-section {
        height: 50vh;
    }

    .logo {
        width: 50%;
        height: 50%;
        margin-bottom: 1rem;
    }

}
</style>
